/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['login{display:block;height:100%;background-color:#fafafa}login>.auth-page .remember-and-login-row{display:-webkit-box;display:-ms-flexbox;display:flex}login>.auth-page .remember-and-login-row>.remember-me-checkbox{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding-top:8px}login>.auth-page .remember-and-login-row>.login-button{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;text-align:right}login>.auth-page .info-row{margin:35px 0;text-align:center;color:#797979}login>.auth-page .social-icons{text-align:center}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9hdXRoL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2F1dGgvbG9naW4vbG9naW4uY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/auth/login/login.component.scss.ngstyle.ts